import PATH from "constants/path";

const LIST_SIDEBAR = [
  {
    path: ["/", "/promotions"],
    name: "モニター募集一覧",
  },
  {
    path: [PATH.ENTRIES],
    name: "応募中案件",
  },
  {
    path: [PATH.MY_POINT],
    name: "現在の保有ポイント",
  },
  {
    path: [PATH.PAYMENT],
    name: "支払履歴",
  },
  {
    path: [PATH.SETTING, PATH.MEMBER_INFO, PATH.CHANGE_LOGIN, PATH.CHANGE_EMAIL, PATH.ACCOUNT_INFO, PATH.PASSWORD],
    name: "会員設定",
  },
];

export { LIST_SIDEBAR };
